import { headerShipToAddressStyles } from "@insite/content-library/Widgets/Common/HeaderShipToAddress";
import { css } from "styled-components";

// EC-94 : B2B Website Header
// Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments.
headerShipToAddressStyles.titleTypography = {
    transform: "capitalize",
    ellipsis: true,
};
// End: Refactored dynamic CSS from CMS to code for consistent behavior across environments.